<template>
  <div
    class="month-entry"
    @click="openTimeBlockShowDetailsModal"
    :class="{ 'conflict-entry': isConflict, 'cancelled-entry': isCancelled }"
    @mouseenter="emitShowPopup"
    @mouseleave="emitHidePopup"
    :style="{
      backgroundColor: terminEntryDTO.veranstaltung
        ? terminEntryDTO.veranstaltung.color
        : '',
    }"
  >
    <div class="entry-compact">
      <span class="entry-time-compact">
        {{ terminEntryDTO.von_uhrzeit }} - {{ terminEntryDTO.bis_uhrzeit }}
      </span>
      <span class="entry-title-compact">
        {{ terminEntryDTO.bezeichnung || '(No subject)' }}
      </span>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'MonthCalendarEntry',

    props: {
      terminEntryDTO: {
        type: Object,
        required: true,
      },
      dayConflicts: {
        type: Array,
        default: () => [],
      },
    },

    computed: {
      terminConflicts() {
        const conflicts = this.dayConflicts.find(
          (conflict) => conflict.termin_id === this.terminEntryDTO.id
        )

        if (!conflicts) return []

        return [
          ...conflicts.room_conflicts.flatMap((conflict) => [
            {
              type: 'Room',
              designation: conflict.conflicting_resource,
              tooltip: conflict.designation.join(','),
              conflictId: conflict.termin_id,
            },
          ]),
          ...conflicts.people_conflicts.flatMap((conflict) => [
            {
              type: 'People',
              designation: conflict.conflicting_resource,
              tooltip: conflict.designation.join(','),
              conflictId: conflict.termin_id,
            },
          ]),
        ]
      },

      isConflict() {
        return this.terminConflicts.length > 0
      },

      isCancelled() {
        return this.terminEntryDTO.ressourcenstatus?.id === '17506F1D261'
      },
    },

    methods: {
      emitShowPopup(event) {
        const rect = event.target.getBoundingClientRect()
        this.$emit('show-popup', {
          entry: this.terminEntryDTO,
          conflicts: this.terminConflicts,
          rect,
        })
      },
      emitHidePopup() {
        this.$emit('hide-popup')
      },

      ...mapActions('FeatureMetadata', ['openTimeBlockModal']),
      ...mapActions('VisualPlannerMetadata', ['setActiveTerminEntry']),
      ...mapActions('VisualPlannerMetadata', ['setActiveTerminConflict']),

      openTimeBlockShowDetailsModal() {
        this.setActiveTerminEntry(this.terminEntryDTO)
        this.setActiveTerminConflict(this.terminConflicts)
        this.openTimeBlockModal()
        this.$emit('close-popup')
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import '@/features/visual_planner/scss/color';

  .month-entry {
    position: relative;
    height: 20px;
    background: $color-bg-secondary;
    border-left: 6px solid $color-border-secondary;
    border-radius: 4px;
    margin-bottom: 1px;
    cursor: pointer;
    background-clip: padding-box;

    &:hover {
      z-index: 1000;

      .corner-icon {
        opacity: 1;
      }
    }

    &.conflict-entry {
      border-left-color: $color-danger;
    }

    &.cancelled-entry {
      opacity: 0.5;
      text-decoration: line-through;
      border-left-color: $color-text-secondary;
    }
  }

  .corner-icon {
    position: absolute;
    top: 2px;
    right: 2px;
    width: 12px;
    height: 12px;
    padding: 2px;
    border-radius: 100%;
    border: 1px solid $color-border-primary;
    opacity: 60%;
    cursor: pointer;
    transition: opacity 0.2s;
    z-index: 2;

    &:hover {
      opacity: 1;
    }
  }

  .entry-compact {
    display: flex;
    align-items: center;
    gap: 4px;

    padding: 2px 8px;
    font-size: 0.75rem;
    color: $color-text-primary;

    white-space: nowrap;
    overflow: hidden; /* NEU: verhindert horizontales Scrollen */
  }

  .entry-time-compact {
    flex: 0 0 auto; // fix – schrumpft nicht
    opacity: 0.3;
  }

  .entry-title-compact {
    flex: 1 1 auto; // nimmt Restbreite
    min-width: 0; // WICHTIG für Flex + Ellipsis
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
